import React, {useContext} from 'react';
import axios from "axios";
import AuthService from "../../services/authService";
import {TourContext} from "../../contexts/TourContext";


const ConnectingQuestions = ({...props}) => {
    const {state} = useContext(TourContext)
    // console.log('bring on the CQ props: ', props)
    // constructor(props) {
    //     super(props);
    //     this.config = {
    //         headers: {'Authorization': "bearer " + AuthService.getToken()}
    //     };
    //
    // }

    const config = {
        headers: {'Authorization': "bearer " + AuthService.getToken()}
    };

    const openPDF = () => {
        // open PDF
        if (!state.isOpen) {
            // post action
            markReviewed();
            // console.log("the connecting button was clicked and props", this.props);
            props.fillReviewedHeart();
        } else {

        }

    }

    const markReviewed = () => {
        // send action Reviewed to API
        let dataURL = "https://onamfc.com/api/progress";

        axios.post(dataURL, {
            progress: {
                "category_id": props.categoryId,
                "action": 'reviewed'
            }
        }, config).then(response => {
            //update the user object in local storage
            AuthService.setUser(response.data)
        });
    }



    return (
        <div className="connecting-questions">
            {
                !state.isOpen ?
                    <a data-tut="reactour__cq_button" href={props.link} target="_blank">
                        <button onClick={openPDF.bind(this)} className="yellow-btn">Connecting Questions</button>
                    </a>
                    :
                    <button data-tut="reactour__cq_button" className="yellow-btn">Connecting Questions</button>
            }

        </div>
    );


}

export default ConnectingQuestions;
